import useCategorySingle from "../../data/Category/useCategorySingle";
import Modal from "../../layouts/Modal";
import { IPartCategory } from "../../models/Category/Category";
import CategoryDetails from "./CategoryDetails";


export default function CategoryModal({
  open,
  setOpen,
  categoryId,
  defaultName,
  onCreated,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  categoryId?: string;
  /** Pre-fills the name of a new category. */
  defaultName?: string;
  /** Stay on the current page after creating, and receive the new category. See CategoryDetails. */
  onCreated?: (category: IPartCategory) => void;
}) {
    const { category, create, update } = useCategorySingle(categoryId);

    return (
        <Modal open={open} setOpen={setOpen} width="sm:max-w-2xl">
             <div className="flex justify-between items-center">
                <h1 className="text-xl">{category?.data ? "Edit " + category.data.name : "Add a category"}</h1>
            </div>
            <div className="mt-4">
                <CategoryDetails
                  category={category?.data ?? undefined}
                  update={update}
                  create={create}
                  open={open}
                  setOpen={setOpen}
                  defaultName={defaultName}
                  onCreated={onCreated}
                />
                <br />
            </div>
        </Modal>
    );
}
